import type { FC } from 'react'
import { HBox } from '../layout/horizontal-box.js'
import { PulseProgress } from './pulse.js'
import type { PulseProps } from './pulse.js'
import { Typography } from '@mui/material'

export interface PulseProgressBoxProps extends PulseProps {
  title?: string
}

export const PulseProgressBox: FC<PulseProgressBoxProps> = props => {
  const { title } = props
  return (
    <HBox sx={{ flex: 1, alignItems: 'center', justifyContent: 'center', flexDirection: 'column' }}>
      <PulseProgress {...props} />
      {title ? (
        <Typography variant="caption" sx={{ mt: 1, color: 'text.secondary' }}>
          {title}
        </Typography>
      ) : null}
    </HBox>
  )
}

export default PulseProgressBox
